import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const HotelFinalBookingSkeleton = () => {
  return (
    <div>
      <div className="" style={{ position: "relative" }}>
        <div
          className="hotelFinalBooking_MainBg"
          style={{ height: "150px" }}
        ></div>
        <div className="hotelFinalBooking_Main">
          <div className="hotelFinalBooking_Containers">
            <Container>
              <Row>
                <Col md={9}>
                  <div className="hotelFinalBooking_ReviewBooking">
                    <div className="hotelFinalBooking_reviewBook">
                      <h3>
                        <Skeleton width={150} />
                      </h3>
                    </div>
                    <div className="hotelFinalBooking_reviewBook">
                      <h4>
                        <Skeleton width={100} />
                      </h4>
                    </div>
                  </div>

                  <div className="hotelFinalBooking_hotelDetails">
                    <div className="hotelFinalBooking_hotelNameAdd">
                      <div className="hotelListingstyling-name hotelFinalBooking-name">
                        <Skeleton width={250} />
                      </div>
                      <div className="hotel-Address">
                        <span>
                          <Skeleton width={400} />
                        </span>
                      </div>
                    </div>

                    <Row className="hotelFinalBooking_rowCols">
                      <Col md={4} className="hotelFinalBooking_Col1">
                        <Skeleton width={270} height={160} />
                      </Col>
                      <Col md={8} className="hotelFinalBooking_Col2">
                        <div
                          className="hotelFinalBooking_CheckinDetails"
                          style={{ flexDirection: "column" }}
                        >
                          {/* <div className="hotelFinalBooking_checkIn">
                            <h6>
                              {" "}
                              <Skeleton width={100} />{" "}
                            </h6>
                            <h3>
                              {" "}
                              <Skeleton width={200} />
                            </h3>
                          </div>
                          <h6>
                            {" "}
                            <Skeleton width={100} />{" "}
                          </h6>
                          <div className="hotelFinalBooking_checkOut">
                            <h6>
                              {" "}
                              <Skeleton width={100} />{" "}
                            </h6>
                            <h3>
                              {" "}
                              <Skeleton width={200} />
                            </h3>
                          </div> */}
                          <div>
                            <Skeleton width={600} />
                          </div>
                          <div>
                            <Skeleton width={600} />
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginBottom: "10px",
                          }}
                        >
                          <Skeleton width={300} />
                          <div>
                            <Skeleton width={450} />
                          </div>
                        </div>

                        {/* <div className="hotelFinalBooking_roomsGuests">
                          <h6>
                            {" "}
                            <Skeleton width={200} />{" "}
                          </h6>
                          <h6 style={{ display: "flex" }}>
                            <span className="hotelFinalBooking_roomsGuests_Span">
                              <Skeleton width={50} />
                            </span>{" "}
                            <span className="hotelFinalBooking_roomsGuests_Span">
                              <Skeleton width={50} />
                            </span>
                          </h6>
                        </div> */}
                      </Col>
                    </Row>

                    {/* <div className="hotelFinalBooking_roomType">
                      <h6>
                        <Skeleton width={300} />
                      </h6>
                      <div>
                        <span className="hotelFinalBooking_roomsGuests_Span">
                          <Skeleton width={150} />{" "}
                        </span>{" "}
                      </div>

                      <div className="hotelFinalBooking_inclusion">
                        <Skeleton width={100} />
                      </div>
                    </div> */}
                    <div>
                      <Skeleton height={30} />
                    </div>
                  </div>

                  <div className="traveller_info hotelFinalBooking_guestInfo">
                    <h4>
                      {" "}
                      <Skeleton width={200} />
                    </h4>

                    <React.Fragment>
                      <Row>
                        <Col sm={2} className="hotelFinalBooking_guestRoomsCol">
                          <label className="hotelFinalBooking_guestLabel hotelFinalBooking_guestRooms">
                            <Skeleton width={100} />
                          </label>
                        </Col>
                      </Row>

                      <Row
                        className="hotelFinalBooking_guestRow"
                        style={{ marginTop: "20px" }}
                      >
                        <Col sm={2} className="hotelFinalBooking_guestLabelCol">
                          <label className="hotelFinalBooking_guestLabel">
                            <Skeleton width={100} />
                          </label>
                        </Col>
                        <Col
                          sm={10}
                          className="hotelFinalBooking_guestInputsCol"
                        >
                          <Row className="hotelFinalBooking_inputRow">
                            <Col
                              sm={2}
                              className="hotelFinalBooking_inputRowCol"
                            >
                              <div className="hotelFinalBooking_SelectWrapper">
                                <Skeleton width={100} height={30} />
                              </div>
                            </Col>
                            <Col
                              sm={5}
                              className="hotelFinalBooking_inputRowCol"
                            >
                              <Skeleton width={250} height={30} />
                            </Col>
                            <Col
                              sm={5}
                              className="hotelFinalBooking_inputRowCol"
                            >
                              <Skeleton width={250} height={30} />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="hotelFinalBooking_guestRow">
                        <Col sm={2} className="hotelFinalBooking_guestLabelCol">
                          <label className="hotelFinalBooking_guestLabel">
                            <Skeleton width={100} />
                          </label>
                        </Col>
                        <Col
                          sm={10}
                          className="hotelFinalBooking_guestInputsCol"
                        >
                          <Row className="hotelFinalBooking_inputRow">
                            <Col
                              sm={2}
                              className="hotelFinalBooking_inputRowCol"
                            >
                              <div className="hotelFinalBooking_SelectWrapper">
                                <Skeleton width={100} height={30} />
                              </div>
                            </Col>
                            <Col
                              sm={5}
                              className="hotelFinalBooking_inputRowCol"
                            >
                              <Skeleton width={250} height={30} />
                            </Col>
                            <Col
                              sm={5}
                              className="hotelFinalBooking_inputRowCol"
                            >
                              <Skeleton width={250} height={30} />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </React.Fragment>

                    <Row>
                      <Col sm={2}></Col>
                      <Col sm={10} className="hotelFinalBooking_inputRowCol">
                        <div
                          className="hotelFinalBooking_bookingDetailsForm"
                          id="contactDetails"
                        >
                          <p className="hotelFinalBooking_font14 hotelFinalBooking_bold appendBottom15">
                            <Skeleton height={20} />
                          </p>
                        </div>

                        <Row className="hotelFinalBooking_adultItemRow">
                          <Col
                            sm={2}
                            xs={4}
                            className="hotelFinalBooking_inputRowCol"
                          >
                            <div className="hotelFinalBooking_adultItem">
                              <div className="hotelFinalBooking_selectItem">
                                <Skeleton width={100} height={50} />
                              </div>
                            </div>
                          </Col>

                          <Col
                            sm={5}
                            xs={8}
                            className="hotelFinalBooking_inputRowCol"
                          >
                            <div className="hotelFinalBooking_adultItem">
                              <Skeleton width={250} height={50} />
                            </div>
                          </Col>

                          <Col sm={5} xs={12}>
                            <div className="hotelFinalBooking_adultItem">
                              <Skeleton width={250} height={50} />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </Col>

                <Col md={3}>
                  <div className="hotelFinalBooking_priceSummary">
                    <div className="hotelFinalBooking_fareSummary">
                      <div>
                        <Skeleton width={70} />
                      </div>
                      <div>
                        <Skeleton width={70} />
                      </div>
                    </div>
                    <div className="hotelFinalBooking_BasefareSummary">
                      <div>
                        <Skeleton width={70} />{" "}
                      </div>
                      <div>
                        <Skeleton width={70} />
                      </div>
                    </div>
                    <div className="hotelFinalBooking_BasefareSummary">
                      <Skeleton width={285} />
                      {/* <div>Taxes & Surcharges -</div>
                      <div>₹ 10000</div> */}
                    </div>
                    <div className="hotelFinalBooking_BasefareSummary">
                      <div>
                        <Skeleton width={70} />{" "}
                      </div>
                      <div>
                        <Skeleton width={70} />
                      </div>
                    </div>
                    <div className="hotelFinalBooking_PayAmt">
                      <div>
                        <Skeleton width={70} />{" "}
                      </div>
                      <div>
                        <Skeleton width={70} />
                      </div>
                    </div>
                    <div
                      className="hotelFinalBooking_continueBtn"
                      style={{ background: "#f4f4f4" }}
                    >
                      <Skeleton width={292} height={30} />
                    </div>
                  </div>
                  <div>
                    <div className="hotelFinalBookingPC_desktop"></div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>

      {/* <div className="hotelPreBook-Mobile">
        <div className="hotelPreBookMobile-wrapper">
          <div className="hotelPreBookMobile-header">
            <Link to="/hoteldetailmain">Arrow Left</Link>
            <span className="hotelPreBookMobile-headerText">
              Hotel Review & Traveller
            </span>
          </div>

          <div className="hotelPreBookMobile-card">
            <div className="hotelPreBookMobile-titleRow">
              <div className="hotel-DetailMobile-hotelName">
                <div className="hotelListingstyling-name hotelFinalBooking-name">
                  Hotel Delhi 37
                  <div
                    className="rating-score"
                    style={{ textAlign: "center", fontSize: "18px" }}
                  >
                    5 Stars
                  </div>
                  <div className="hotel-Address hotel-AddressMobile">
                    <span>
                      {" "}
                      A-147 NH-8 Mahipalpur Near IGI Airport Near Indira Gandhi
                      AirportMahipalpurNew Delhi 110037
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <hr className="hotelPreBookMobile-divider" />

            <div className="hotelPreBookMobile-roomRow">
              <div className="hotelPreBookMobile-roomInfo">
                <h4 className="hotelPreBookMobile-roomTitle">Hotel Delhi 37</h4>
                <ul className="hotelPreBookMobile-roomList">
                  <li>Breakfast not included Welcome Drink</li>
                  <li>
                    10% Discount on Food & Soft Beverages…{" "}
                    <span className="hotelPreBookMobile-viewMore">
                      View more
                    </span>
                  </li>
                </ul>
                <div className="hotelPreBookMobile-guestInfo">
                  <span>
                    <span style={{ fontWeight: "bold" }}>4</span> Guests
                  </span>{" "}
                  |{" "}
                  <span>
                    <span style={{ fontWeight: "bold" }}>1</span> Rooms
                  </span>
                </div>
              </div>
              <div className="hotelPreBookMobile-roomImage">
                <img src="/Images/Images/hotelroom.jpg" alt="Room" />
              </div>
            </div>

            <div className="hotelPreBookMobile-dashedDivider"></div>

            <h4 className="hotelPreBookMobile-sectionTitle">
              Travel Dates and Guests
            </h4>

            <div className="hotelPreBookMobile-dateBox">
              <div className="hotelPreBookMobile-dateItem">
                <p className="hotelPreBookMobile-dateLabel">Check-In</p>
                <p className="hotelPreBookMobile-dateDay">11 Aug 2025</p>
              </div>
              <div className="hotelPreBookMobile-nightCircle">1N</div>
              <div className="hotelPreBookMobile-dateItem">
                <p className="hotelPreBookMobile-dateLabel">Check-Out</p>
                <p className="hotelPreBookMobile-dateDay">11 Aug 2025</p>
              </div>
            </div>

            <p className="hotelPreBookMobile-inclusionsLink">Inclusions</p>
          </div>
        </div>

        <div className="hotelTravellerMobile-wrapper">
          <div className="hotelPreBookMobile-priceCard">
            <h4 className="hotelPreBookMobile-sectionTitle">Price Breakup</h4>
            <p className="hotelPreBookMobile-priceSubtitle">
              A detailed breakdown of costs associated with hotel
            </p>
            <hr className="hotelPreBookMobile-divider" />

            <div className="hotelPreBookMobile-priceRow">
              <span>Base Fare -</span>
              <span>₹ 100</span>
            </div>
            <div className="hotelPreBookMobile-priceRow">
              <span>Taxes & Surcharges -</span>
              <span>₹ 1000</span>
            </div>
            <div className="hotelPreBookMobile-priceRow">
              <span>Discount -</span>
              <span>₹ 0</span>
            </div>
            <div className="hotelPreBookMobile-grandTotal">
              <span>You Pay: -</span>
              <span className="hotelPreBookMobile-grandTotalAmount">₹ 490</span>
            </div>
          </div>
        </div>

        <div className="hotelTravellerMobile-wrapper">
          <div className="hotelTravellerMobile-card">
            <h4 className="hotelTravellerMobile-title">Traveller Details</h4>
            <p className="hotelTravellerMobile-subtitle">
              Enter your details as per your Aadhar Card
            </p>

            <div className="hotelTravellerMobile-row">
              <div className="hotelTravellerMobile-inputGroup">
                <label>Title</label>
              </div>
              <div className="hotelTravellerMobile-inputGroup">
                <label>First (& Middle Name if any)</label>
              </div>
            </div>

            <div className="hotelTravellerMobile-inputGroup">
              <label>Last Name</label>
            </div>

            <p className="hotelTravellerMobile-addMore">+ Add More Guest</p>
          </div>

          <h4 className="hotelTravellerMobile-subsection">
            Contact Information
          </h4>

          <div className="hotelTravellerMobile-inputGroup">
            <label>Email Id</label>
            Email Id
          </div>

          <div className="hotelTravellerMobile-row">
            <div className="hotelTravellerMobile-inputGroup">
              <label>Mobile No</label>
              <div className="hotelTravellerMobile-mobileRow">
                Contct number
              </div>
            </div>
          </div>

          <div className="hotelTravellerMobile-priceBar">
            <div>
              <div className="hotelPreBookMobile-guestInfo">
                <span>
                  <span style={{ fontWeight: "bold" }}>5</span> Guests
                </span>{" "}
                |{" "}
                <span>
                  <span style={{ fontWeight: "bold" }}>1</span> Rooms
                </span>
              </div>
              <strong style={{ color: "#878787" }}>₹ 100</strong>
            </div>
            <button className="hotelFinalBooking_continueBtn">Continue</button>
          </div>
        </div>

      </div> */}
    </div>
  );
};

export default HotelFinalBookingSkeleton;
